import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";
import { MediasClimaticasResponse } from "../partials/diario/mediasClimaticas.types";

export function useGetMediasClimaticas(safraId?: string, unidadeId?: string) {
  const url =
    safraId && unidadeId
      ? URL.CLIMATOLOGIA.MEDIAS_CLIMATICAS(safraId, unidadeId)
      : null;

  return useQuery(
    [URL.CLIMATOLOGIA.MEDIAS_CLIMATICAS, safraId, unidadeId],
    async () => {
      const { data } = await http.get<MediasClimaticasResponse>(url as string, {
        headers: {
          "api-version": "1.0",
        },
      });
      return data;
    },
    {
      enabled: !!safraId && !!unidadeId && !!url,
      keepPreviousData: true,
    }
  );
}
